import React from 'react';
import { useNavigate } from 'react-router-dom';
import PowerBIEmbed from '../../components/PowerBIEmbed';
import './styles.css';

const HotelsPage = () => {
  const navigate = useNavigate();

  return (
    <div className="sector-page">
      <header className="sector-header">
        <div>
          <h1>Hotels Sector</h1>
          <p className="sector-subtitle">Overview</p>
        </div>
        <button 
          className="back-to-dashboard-btn"
          onClick={() => navigate('/dashboard')}
        >
          Back to Dashboard
        </button>
      </header>
      <div className="sector-content">
        <div className="sector-iframe-wrapper">
          <PowerBIEmbed />
        </div>
      </div>
    </div>
  );
};

export default HotelsPage;


